import { FC, ReactNode } from 'react';
import AccordionBlock from './AccordionBlock';
import { AccordionGroup } from '@kpa/kul';
import { ContentResponse } from '../../types/shared';
import { AccordionGroupBlockResponse } from '../../types/blocks';

interface IAccordionGroupBlock {
  content: ContentResponse;
}

const AccordionGroupBlock: FC<IAccordionGroupBlock> = ({ content }): ReactNode => {
  const responseContent = content.content as AccordionGroupBlockResponse;
  return (
    <AccordionGroup>
      {responseContent.accordionGroup.map((accordion, index) => (
        <AccordionBlock content={accordion} key={index} />
      ))}
    </AccordionGroup>
  );
};

export default AccordionGroupBlock;
